import React from "react";
import styles from "./ErrorPage.module.css";

export const ErrorPage: React.FC = () => {

    return <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
            <span className={styles.title}>Sorry, something went wrong</span>
            <span
                className={styles.subtitle}>Please ping support</span>
        </div>
    </div>
}
